// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a61ca578","453":"0078e984","667":"3cb807a5"}[chunkId] + ".chunk.js";
};